import React from 'react';
import { PressReleaseCard } from '@components/PressReleaseCard';
import { Grid } from '@mui/material';
import { articleStyles as classes } from './styleObjects/articleStyles';
import { BottomArticleCardList } from '@components/BottomArticleCardList';
import { RelatedPosts } from '@components/PressRoomHome/RelatedPosts';
import { useTranslation } from '@stateManagement/TranslationContext';
import { Redirect } from '@components/Redirect';
import { getTranslation } from '@helpers/languageTranslations';
import { languageRouteTypes } from '@helpers/languageRoutes';
import { cleanEscapes } from '@helpers/string';
import { getPressReleaseStructuredDataScript } from '@helpers/articleScriptHelper';
import { ArticleSectionPageHelmet } from '@components/BlogSection/ArticleSectionPageHelmet';
import { ArticleHeader } from '@components/ArticleHeader';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { Heading } from '@web-for-marketing/react-ui';

export default function PressRoomRelease(): React.ReactElement | null {
    const { selectedLanguageTranslation } = useTranslation();
    const { prefixStringWithBaseUrl, pressRelease, mediaUrlPrefix, fullUrl } = useStaticValues();
    const cleanFullUrl = cleanEscapes(fullUrl, '"');
    const pressReleaseArticle = pressRelease.articleData;
    const hasHeadermedia =
        pressReleaseArticle?.pressRelease.imageUrl || pressReleaseArticle?.pressRelease.mobileImageUrl;

    return pressReleaseArticle ? (
        pressReleaseArticle.pressRelease.redirectUrl ? (
            <Redirect statusCode={200} redirectUrl={pressReleaseArticle.pressRelease.redirectUrl} />
        ) : (
            <>
                <ArticleSectionPageHelmet
                    article={pressRelease}
                    articleType='pressRelease'
                    noIndex={pressReleaseArticle.pressRelease.noIndex}
                    script={getPressReleaseStructuredDataScript(
                        pressReleaseArticle.pressRelease,
                        mediaUrlPrefix,
                        prefixStringWithBaseUrl,
                        cleanFullUrl
                    )}
                />
                <Grid container direction='column'>
                    <Grid item css={classes.header}>
                        <ArticleHeader article={pressReleaseArticle.pressRelease} />
                    </Grid>
                    <Grid>
                        <Grid
                            container
                            spacing={6}
                            css={[
                                { margin: '-24px', '& > .MuiGrid-item': { padding: '24px' } },
                                classes.centeredContainer,
                                classes.mobileWrap,
                            ]}
                            wrap='nowrap'
                        >
                            <Grid
                                item
                                md={12}
                                lg={8}
                                css={hasHeadermedia ? classes.pressReleaseCard : classes.noHeaderMediaCard}
                            >
                                <PressReleaseCard pressRelease={pressReleaseArticle.pressRelease} />
                            </Grid>
                            <Grid item md={12} lg={4}>
                                <Heading variant='h2' color='primary'>
                                    {getTranslation(selectedLanguageTranslation, 'relatedPosts')}
                                </Heading>
                                <RelatedPosts pressReleaseList={pressReleaseArticle.relatedPosts} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container css={[classes.centeredContainer, classes.block]}>
                            <Grid css={classes.recentNewsContainer}>
                                <Heading variant='h2' color='primary'>
                                    {getTranslation(selectedLanguageTranslation, 'recentNews')}
                                </Heading>
                                <BottomArticleCardList
                                    articleList={pressReleaseArticle.recentNews}
                                    routeType={languageRouteTypes.PRESS_RELEASE}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    ) : null;
}
